module["exports"] = ["Bay", "Bayan", "Dr.", "Prof. Dr."];